/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: c8f166fa9b87
 */

import * as z from "zod";
import { foldersCreateFolder } from "../../funcs/foldersCreateFolder.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  folder: z.string().describe(
    "The full path of the folder, including any nested folders. Must not be empty, and must not contain double slashes or leading/trailing slashes.",
  ),
};

export const tool$foldersCreateFolder: ToolDefinition<typeof args> = {
  name: "create-folder",
  description: `Creates a new empty folder in your Cloudinary media library

Creates a new folder at the specified path`,
  scopes: ["librarian"],
  annotations: {
    "title": "Create Folder",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await foldersCreateFolder(
      client,
      args.folder,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
